// extracted by mini-css-extract-plugin
export default {"root":"SharingNewUnMount__root--3gLnP"};